import { Button, Input, Spinner } from 'avo-ui'
import Datepicker from 'components/commons/datepicker'
import TabToggle from 'components/commons/tab-toogle'
import Timepicker from 'components/commons/timepicker'
import UploadImage from 'components/commons/upload-image'
import moment from 'moment'

export const ThankYou = ({ data, onChangeForm, isFormValid, isLoadingUpload, isLoading, isUpdating, onSubmit }) => {
    return (
        <div className={'flex flex-col space-y-3 px-9 py-4'}>
            {isLoading ? (
                <Spinner className={'w-8 h-8 my-10 mx-auto !border-blue-50'} />
            ) : (
                <>
                    <TabToggle
                        className={'overflow-hidden'}
                        title={'General'}
                        content={
                            <div className={'flex flex-col space-y-16'}>
                                <div className={'flex space-x-16'}>
                                    <div className={`flex-1 flex-col space-y-3`}>
                                        <div className={'font-semibold text-blue-90 required'}>
                                            Background Desktop (1200px x 358px)
                                        </div>
                                        <UploadImage
                                            className={'w-fit'}
                                            classNameImage={
                                                '!w-fit !h-fit max-h-80 border border-neutral-30 rounded-md'
                                            }
                                            id={`background-desktop`}
                                            value={data?.desktop_background?.base64 || data?.desktop_background}
                                            onChange={(value) => onChangeForm({ name: 'desktop_background', value })}
                                        />
                                    </div>

                                    <div className={`flex-1 flex-col space-y-3`}>
                                        <div className={'font-semibold text-blue-90 required'}>
                                            Background Mobile (393px x 215px)
                                        </div>
                                        <UploadImage
                                            className={'w-fit'}
                                            classNameImage={
                                                '!w-fit !h-fit max-h-80 border border-neutral-30 rounded-md'
                                            }
                                            id={`background-mobile`}
                                            value={data?.mobile_background?.base64 || data?.mobile_background}
                                            onChange={(value) => onChangeForm({ name: 'mobile_background', value })}
                                        />
                                    </div>
                                </div>
                                <div className={'flex space-x-16'}>
                                    <div className={'flex-1 flex-col space-y-3'}>
                                        <div className={'font-semibold text-blue-90 required'}>Title</div>
                                        <Input
                                            className={'flex-1'}
                                            name={'title'}
                                            placeholder={'Masukkan title'}
                                            value={data?.title}
                                            onChange={onChangeForm}
                                        />
                                    </div>
                                    <div className={'flex-1 flex-col space-y-3'}>
                                        <div className={'font-semibold text-blue-90 required'}>Countdown pengumuman pemenang</div>
                                        <div className={'flex space-x-2'}>
                                            <Datepicker
                                                name={'date'}
                                                className={'flex-1'}
                                                value={data?.date}
                                                minDate={moment()}
                                                onChange={(value) => onChangeForm({ name: 'date', value })}
                                                format={'YYYY-MM-DD'}
                                            />
                                            <Timepicker
                                                className={'flex-1'}
                                                name={'time'}
                                                placeholder='Pilih Waktu'
                                                value={data?.time}
                                                disabled={!data?.date}
                                                onChange={(value) => onChangeForm(value)}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    />
                    <div className={'flex py-3 justify-center'}>
                        <Button
                            className={'w-[200px]'}
                            loading={isLoadingUpload || isUpdating}
                            disabled={!isFormValid()}
                            title={'Submit'}
                            onClick={onSubmit}
                        />
                    </div>
                </>
            )}
        </div>
    )
}
